import router from "../base/lib/router";

export default {
    request
}
type RequestKey = string
type RequestOptions = {
    method?: string
    body?: any
}

const inFlightRequests: Map<RequestKey, Promise<any>> = new Map()

function getRequestKey(url: string, method: string, body: any): RequestKey {
    return JSON.stringify({ url, method, body })
}

export async function request(
    url: string,
    method = 'GET',
    body: any = null
): Promise<any> {
    const key = getRequestKey(url, method, body)

    if (inFlightRequests.has(key)) {
        return inFlightRequests.get(key)
    }

    try {
        const options: RequestInit = {
            method,
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem('DANESH_FX_ADMIN_TOKEN'),
            },
        }

        if (body) {
            options.body = JSON.stringify(body)
        }

        const fetchPromise = fetch(url, options).then(async (response) => {
            inFlightRequests.delete(key)

            if (response.status === 401 || response.status === 403) {
                localStorage.removeItem('DANESH_FX_ADMIN_TOKEN')
                alert('Your session has expired. Please sign in again.')
                router.goto('/login')
                throw new Error('Session expired')
            }

            if (!response.ok) {
                let message = 'Network response was not ok'
                try {
                    const data = await response.json()
                    if (data && data.message) message = data.message
                } catch (_) { /* response had no JSON body */ }
                throw new Error(message)
            }

            return response.json()
        })

        inFlightRequests.set(key, fetchPromise)

        return await fetchPromise
    } catch (error) {
        // If there's an error, remove from map so that future requests
        // won't wait on a rejected promise
        inFlightRequests.delete(key)
        console.error('There was a problem with the API request:', error)
        throw error
    }
}
